import SupportRequestsContainer from './SupportRequestsContainer';

export default SupportRequestsContainer;
